// This file was automatically generated from data.practices.html.
// Please don't edit this file by hand.

goog.provide('el8.template.data.practices');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.data.practices.header = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (el8Globals.PRINT_HEADER) {
    el8.template.data.practices.customHeader({header: el8Globals.PRINT_HEADER}, output);
  } else {
    output.append('<div class="pageHeaderContainer"><ul class="pageHeader"><li class="first">', soy.$$escapeHtml(opt_data.name), '</li></ul><ul class="pageHeader"><li>', (opt_data.addressLine) ? soy.$$escapeHtml(opt_data.addressLine) + ', ' : '', soy.$$escapeHtml(opt_data.cityStateZip), '</li></ul><ul class="pageHeader">', (opt_data.phone) ? '<li class="first">Office: ' + soy.$$escapeHtml(opt_data.phone) + ((opt_data.fax) ? '; ' : '') + '</li>' : '', (opt_data.fax) ? '<li class="last">Fax: ' + soy.$$escapeHtml(opt_data.fax) + '</li>' : '', '</ul></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.data.practices.customHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageHeaderContainer">');
  if (opt_data.header.contentType == 0) {
    output.append('<div class="el8Preserve">', soy.$$escapeHtml(opt_data.header.header), '</div>');
  } else if (opt_data.header.contentType == 1) {
    if (opt_data.header.headerImage) {
      output.append('<img class="header-image" style="display:block;');
      switch (opt_data.header.imagePlacement) {
        case 0:
          output.append('max-height:', soy.$$escapeHtml(Math.min(100, opt_data.header.headerImageHeight / 4)), 'px; min-height:20px; max-width:100%;"');
          break;
        case 1:
          output.append('margin:0 0 0 auto; max-height:', soy.$$escapeHtml(Math.min(100, opt_data.header.headerImageHeight / 4)), 'px; min-height:20px; max-width:100%;"');
          break;
        case 2:
          output.append('margin:0 auto; max-height:', soy.$$escapeHtml(Math.min(100, opt_data.header.headerImageHeight / 4)), 'px; min-height:20px; max-width:100%;"');
          break;
        default:
          output.append('width:100%; max-height:616px;"');
      }
      output.append('src="', soy.$$escapeHtml(opt_data.header.headerImage), '"></img>');
    }
  } else {
    output.append('<p>Error: Unknown header content type</p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
